import React from 'react';
import {FormProvider, useForm, UseFormReturn, UseFormProps, FieldValues} from 'react-hook-form';

/**
 * If your FORM FIELDS are outside of your main file then use the following :
 * ```
 *      const methods = useFormContext();
 *      <input {...methods.register("nestedInput")} />
 * ```
 * Else, use the `methods` prop passed down from withRHForm
 */
export interface WithRHFormProviderProps<TFormFieldValues = FieldValues> {
    methods: UseFormReturn<TFormFieldValues>;
}

export default function withRHFormProvider<TProps, TFormFieldValues>(
    DeepNestedFormFieldComponents: React.ComponentType<
        TProps & WithRHFormProviderProps<TFormFieldValues>
    >,
    options?: UseFormProps<TFormFieldValues>
) {
    const WithReactHookFormComp: React.FC<TProps> = props => {
        const methods = useForm<TFormFieldValues>(options);
        return (
            <FormProvider {...methods}>
                <DeepNestedFormFieldComponents {...props} methods={methods} />
            </FormProvider>
        );
    };

    //@ts-ignore
    WithReactHookFormComp.displayName = `WithReactHookFormComp(${DeepNestedFormFieldComponents.displayName ||
        DeepNestedFormFieldComponents.name ||
        'Component'})`;

    return WithReactHookFormComp;
}
